<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h2>Oferenci</h2>
			<v-spacer></v-spacer>
		</v-card-title>

		<v-layout align-center justify-center row>
			<v-flex xs3>
				<v-combobox
					class="ma-2"
					ref="bidderAutocomplete"
					v-model="dataTable.searchFields.polishName"
					:items="autocompletedBidders"
					:search-input.sync="search"
					item-text="polishName"
					item-value="polishName"
					label="Nazwa"
					:return-object="false"
					:no-filter="true"
					clearable
				></v-combobox>
			</v-flex>
			<v-flex xs3>
				<v-autocomplete
					class="ma-2"
					v-model="dataTable.searchFields.legalForm"
					:items="legalFormList"
					label="Forma prawna"
					aria-label="legal form"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs4>
				<v-layout align-center justify-center row>
					<v-btn @click="buildNewSearch" color="primary" dark class="mb-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="mb-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="mb-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1"
		>
			<template slot="items" slot-scope="props">
				<td>{{props.item.name}}</td>
				<td>{{props.item.legalForm}}</td>
				<td class="text-xs-left">
					<span class="notAccepted-bidder" v-if="props.item.accepted === false"
						style="color:darkred"><b>Niezaakceptowany</b><br></span>
					<span class="active-bidder" v-else-if="props.item.active === true" style="color:#0075e2">Aktywny</span>
					<span class="inactive-bidder" v-else style="color:red">Nieaktywny</span>
				</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon v-if="!roles.isDepartmentEmployee()"
								@click="deleteItem(props.item)" >
								<v-icon v-on="on" color="lightred">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="showProfile(props.item)" >
								<v-icon v-on="on">
									person
								</v-icon>
							</v-btn>
						</template>
						<span>Profil</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="showSubBidders(props.item)" >
								<v-icon v-on="on">
									groups
								</v-icon>
							</v-btn>
						</template>
						<span>Subkonta</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon
								@click="showBidderData(props.item)">
								<v-icon v-on="on">
									description
								</v-icon>
							</v-btn>
						</template>
						<span>Aktywność oferenta</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon
								@click="showProjects(props.item)">
								<v-icon v-on="on">
									business
								</v-icon>
							</v-btn>
						</template>
						<span>Projekty</span>
					</v-tooltip>
					<v-tooltip bottom v-if="(props.item.active === false) && !roles.isDepartmentEmployee()">
						<template v-slot:activator="{ on }">
							<v-btn icon
								@click="activateUser(props.item)" >
								<v-icon v-on="on" color="green">
									check_circle
								</v-icon>
							</v-btn>
						</template>
						<span>Aktywuj</span>
					</v-tooltip>
					<v-tooltip bottom v-else-if="(props.item.active === true) && !roles.isDepartmentEmployee()">
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deactivateUser(props.item)" >
								<v-icon v-on="on" color="lightred">
									lock
								</v-icon>
							</v-btn>
						</template>
						<span>Dezaktywuj</span>
					</v-tooltip>
					<v-tooltip bottom v-if="(props.item.accepted === false) && !roles.isDepartmentEmployee()">
						<template v-slot:activator="{ on }">
							<v-btn icon
								@click="acceptUser(props.item)">
								<v-icon v-on="on" style="color:darkred">
									change_history
								</v-icon>
							</v-btn>
						</template>
						<span>Zaakceptuj</span>
					</v-tooltip>
					<v-tooltip bottom max-width="480px" v-if="props.item.notes && (roles.isAdministrator() || roles.isLocalAdministrator() || roles.isDepartmentEmployee())">
						<template v-slot:activator="{ on }">
							<v-btn icon>
								<v-icon color="lightred" v-on="on">info</v-icon>
							</v-btn>
						</template>
						<span>{{ props.item.notes }}</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {getDictionary} from "@/utils/LegalFormDictionary";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {User} from "@/api/generated/User";
  import {encoder} from "@/utils/encodeHelper";
  import {Filters} from "@/utils/Filters";

  export default {
		name: "AllBiddersView",

    mixins: [Filters],

		watch: {
			dialog (val) {
				if (!val) {
					this.vErrors.clear();
					this.editedIndex = -1;
					this.editedItem = {};
				}
			},

			"dataTable.pagination": {
				handler (pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},

			search() {
				this.autocompleteBidders();
			},
		},

		computed: {
			pages () {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},

			isEdited () {
				return this.editedIndex !== -1;
			},
		},

		data () {
			return {
				legalFormList: [],
				dataTable: {
					searchFields: {
						polishName: "",
						legalForm: ""
					},
					tableHeaders: [
						{text: 'Nazwa', sortable: true, value: 'name'},
						{text: 'Forma prawna', sortable: true, value: 'legalForm'},
						{text: 'Status', sortable: false},
						{text: "Akcje", sortable: false, value: "actions"},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25
					},
					search: "",
				},

				dialog: false,

				search: "",

				autocompletedBidders: [],

				autocompleteDebounce: "",

				editedItem: {},

				editedIndex: -1,

				deletedItem: {},

				clicked: false,
			};
		},

		methods: {

			autocompleteBidders() {
				clearTimeout(this.autocompleteDebounce);
				if (this.search && this.search.length === 1) {
                    return;
                }
				this.autocompleteDebounce = setTimeout(() => {
					let query = encoder.encodeUrlParam(this.search) || "";
					Api.get(this,"/bidder/autocomplete?query=".concat(query), successResponse => {
							this.autocompletedBidders = successResponse;
						},
						errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się załadować danych oferentów", errorResponse);
						}, {ignoreLoader: true});
				}, 400);
			},

			canBeAllowedToView (item) {
				return item.role !== 'Oferent - konto główne' &&
					item.role !== 'Wolontariusz' &&
					item.role !== 'Administrator lokalny' &&
					item.role !== 'Administrator główny';
			},

			buildNewSearch () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				this.getItemList();
			},

			getItemList () {
				if (this.dataTable.pagination.page) {
					let sort = this.buildSort();
					Api.get(this,
						"/all-bidders/list?search=" + this.dataTable.search
							+ "&page=".concat(this.dataTable.pagination.page)
							+ "&result=".concat(this.dataTable.pagination.rowsPerPage)
							+ "&sort=".concat(sort), response => {
								this.dataTable.itemList = response.itemList;
								this.dataTable.itemCount = response.itemCount;
							});
				}
			},

			exportData () {
				if (this.dataTable.pagination.page) {
					let sort = this.buildSort();
					let path = "/all-bidders/export?search=" + this.dataTable.search
						+ "&page=".concat(this.dataTable.pagination.page)
						+ "&result=".concat(this.dataTable.pagination.rowsPerPage)
						+ "&sort=".concat(sort);
					ExportUtils.sendExportRequest(path, this);
				}
			},

			buildSort () {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			resetSearch () {
				this.clearFields();
				this.buildNewSearch();
			},

			clearFields () {
				this.dataTable.searchFields.polishName = "";
				this.dataTable.searchFields.legalForm = "";
			},

			buildSearch (searchFields) {
				let search = "";

				if (searchFields.polishName) {
					search = search.concat("polishName::" + encoder.encodeUrlParam(searchFields.polishName) + "$$");
				}
				if (searchFields.legalForm) {
					search = search.concat("legalForm::" + searchFields.legalForm + "$$");
				}
				return search;
			},

			editItem (item) {
				this.editedIndex = this.dataTable.itemList.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem (item) {
        let confirmationMessage = "Czy na pewno chcesz usunąć oferenta?";
        if (!item.accepted) {
          confirmationMessage = confirmationMessage.concat(" Operacja usunięcia niezaakceptowanego oferenta jest " +
              "nieodwracalna. Oferent zostanie trwale usunięty z systemu.");
        }

				this.$confirm(confirmationMessage, {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie oferenta",
					width: 500
				})
					.then(result => {
						if (result) {
							const index = this.dataTable.itemList.indexOf(item);
							User.delete(this, item.id, successResponse => {
									this.dataTable.itemList.splice(index, 1);
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć użytkownika", errorResponse);
								});
						}
					});
			},

			showProfile (item) {
				if (this.roles.isAdministrator() || this.roles.isLocalAdministrator()) {
					this.$router.push("/app/profile/" + item.id);
				} else {
					this.$router.openInNewTab({name: "profileView", params: {userId: item.id}});
				}
			},

      showSubBidders(item) {
        this.$router.push("/app/bidder/" + item.id + "/sub-bidders");
      },

			showBidderData (item) {
				this.$router.push("/app/bidder-data/" + item.id + "/contest-list");
			},

			showProjects (item) {
				this.$router.push("/app/project/bidder-project-list/".concat(item.id));
			},

			close () {
				this.dialog = false;
			},

			acceptUser (user) {
				this.$confirm("Czy na pewno chcesz zaakceptować użytkownika?", {
					icon: "warning",
					title: "Akceptacja użytkownika",
					color: "info",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.post(this, "/user/accept", {email: user.email}, successResponse => {
									user.accepted = true;
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie zaakceptowany", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się zaakceptować użytkownika", errorResponse);
								});
						}
					});
			},

			activateUser (user) {
				this.$confirm("Czy na pewno chcesz aktywować użytkownika?", {
					icon: "warning",
					title: "Aktywacja użytkownika",
					color: "info",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.post(this, "/user/activate", {email: user.email}, successResponse => {
									user.active = true;
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie aktywowany", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się aktywować użytkownika", errorResponse);
								});
						}
					});
			},

			deactivateUser (user) {
				this.$confirm("Czy na pewno chcesz dezaktywować użytkownika?", {
					icon: "warning",
					title: "Dezaktywacja użytkownika",
					color: "info",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.post(this, "/user/deactivate", {email: user.email}, successResponse => {
									user.active = false;
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie dezaktywowany", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się dezaktywować użytkownika", errorResponse);
								});
						}
					});
			},
		},

    created() {
      this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
      this.buildNewSearch();
    },

    mounted () {
			let dict = getDictionary();
			for (let i = 0; i < Object.keys(dict).length; i++) {
				this.legalFormList.push(dict[i]);
			}
		},
	};
</script>

<style scoped>
	.theme--dark .notAccepted-bidder {
		color: #fff !important;
	}
	.theme--dark .inactive-bidder {
		color: #D5233F !important;

	}
	.theme--dark .active-bidder {
		color: #fff !important;

	}

	.theme--dark .red--text {
		color: #f4ec0d !important;
	}

	.theme--dark .green--text {
		color: #a1f0a4 !important;
	}
</style>
